import type {
    GetEmailSequenceTemplate_emailSequenceTemplate,
    EmailSequenceTemplateTemplate,
} from 'nutshell-graphql-types';

/**
 * Get the list of all sibling email sequence templates
 *
 * This gets the list of all related email sequence templates for a given email
 * sequence template. Either the template is the parent and has the children, or
 * it has a parent and that parent has all children on it.
 */
export function normalizeEmailSequences(
    emailSequenceTemplate: GetEmailSequenceTemplate_emailSequenceTemplate
): EmailSequenceTemplateTemplate[] {
    // @ts-expect-error
    let emailSequences = [];

    if (emailSequenceTemplate.parent) {
        // We have a parent, get the parent and its children
        // @ts-expect-error
        emailSequences = emailSequences.concat(emailSequenceTemplate.parent);

        if (
            emailSequenceTemplate.parent &&
            emailSequenceTemplate.parent.children &&
            emailSequenceTemplate.parent.children.edges
        ) {
            emailSequences = emailSequences.concat(
                emailSequenceTemplate.parent.children.edges.map((child) => {
                    return child.node;
                })
            );
        }
    } else {
        // Otherwise, this is the parent, and we get this sequence and its
        // children
        // @ts-expect-error
        emailSequences = emailSequences.concat({
            ...emailSequenceTemplate,
            parent: emailSequenceTemplate.parent,
        });

        if (emailSequenceTemplate.children && emailSequenceTemplate.children.edges) {
            emailSequences = emailSequences.concat(
                emailSequenceTemplate.children.edges.map((child) => {
                    return child.node;
                })
            );
        }
    }

    return emailSequences;
}
